import React from 'react'
import "./fifth.css"
function Fifth() {
  return (
    <div className="d1 fifth" style={{background:"#0086FB"}}>
<div className='text'>
  <span className='title'>
  run is now
  <br/>
rewarding

  </span><br/>
<span>
Every step you take, every move you make - we will be rewarding you with rare NFTs and in-metaverse tokens that gets deposited to your crypto wallet automatically
</span>
<button className='btn' href="#">Know More</button>
</div>
<div className='img-fifth'>
<img src="fifth.png" />
</div>
     </div>
);
    }
    
   
export default Fifth;